import { motion } from "framer-motion";
import { SearchCheck, Scale, HandCoins } from "lucide-react";

const ITEMS = [
  {
    icon: SearchCheck,
    title: "Deep research",
    text: "Every pick is compared against dozens of alternatives — specs, reviews, and price history.",
  },
  {
    icon: Scale,
    title: "No paid placements",
    text: "Rankings are earned by quality alone. Brands can't buy their way onto this list.",
  },
  {
    icon: HandCoins,
    title: "Real value",
    text: "We track price drops and only feature products genuinely worth their price tag.",
  },
];

export const WhySection = () => (
  <section id="why" className="border-t border-white/10 bg-[#121418]/40">
    <div className="mx-auto max-w-7xl px-5 py-20 md:px-8 md:py-28">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      >
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#FFB800]">Why trust us</p>
        <h2 className="mt-3 max-w-lg font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-50">
          Curated like a friend who reads every review
        </h2>
      </motion.div>
      <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3">
        {ITEMS.map((item, i) => (
          <motion.div
            key={item.title}
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="rounded-2xl border border-white/10 bg-[#121418] p-7 transition-colors duration-300 hover:border-[#FF9900]/40"
          >
            <div className="mb-5 inline-flex rounded-xl border border-[#FF9900]/30 bg-[#FF9900]/10 p-3 text-[#FF9900]">
              <item.icon size={22} />
            </div>
            <h3 className="font-display text-lg font-semibold tracking-tight text-slate-50">{item.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-slate-400">{item.text}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
